import { useContext, useCallback } from 'react'


import { CandidateServiceContext } from './CandidateServiceProvider'

export function useCandidateService() {
    const context = useContext(CandidateServiceContext)

    if (context === null) {
        throw 'Make sure the <CandidateServiceProvider /> component is a parent of this component and in the same react tree'
    }

    return context
}

export function useRejectCandidateBulk() {
    const context = useCandidateService()

    if (!context.rejectCandidateDetailsBulk || typeof context.rejectCandidateDetailsBulk !== 'function') {
        return null
    }

    return useCallback(context.rejectCandidateDetailsBulk, [context])
}

export function useRejectCandidate() {
    const context = useCandidateService()

    if (!context.rejectCandidate || typeof context.rejectCandidate !== 'function') {
        return null
    }


    return useCallback(context.rejectCandidate, [context])
}

export function useSendCandidateMessageBulkAction() {
    const context = useCandidateService()

    if (!context.sendMessage || typeof context.sendMessage !== 'function') {
        return null
    }

    return useCallback(context.sendMessage, [context])
}

export function useSendCandidateNoteBulkAction() {
    const context = useCandidateService()

    if (!context.sendNote || typeof context.sendNote !== 'function') {
        return null
    }

    return useCallback(context.sendNote, [context])
}

export function useGetChangeStatus() {
    const context = useCandidateService()

    if (!context.getChangeStatus || typeof context.getChangeStatus !== 'function') {
        return null
    }

    return useCallback(context.getChangeStatus, [context])
}

export function useGetNextStatusChange() {
    const context = useCandidateService()

    if (!context.getNextStatusChange || typeof context.getNextStatusChange !== 'function') {
        return null
    }

    return useCallback(context.getNextStatusChange, [context])
}

export function useSendChangeStatus() {
    const context = useCandidateService()

    if (!context.changeStatus || typeof context.changeStatus !== 'function') {
        return null
    }

    return useCallback(context.changeStatus, [context])
}
